import { r } from '@zk-kit/baby-jubjub';
import assert from 'assert';
import { keccak256, stringToBytes } from 'viem';

export const SNARK_FIELD_SIZE = r;

// A nothing-up-my-sleeve zero value
// Should be equal to 8370432830353022751713833565135785980866757267633941821328460903436894336785
export const NOTHING_UP_MY_SLEEVE =
  BigInt(keccak256(stringToBytes('Maci'))) % SNARK_FIELD_SIZE;

assert(
  NOTHING_UP_MY_SLEEVE ===
    BigInt(
      '8370432830353022751713833565135785980866757267633941821328460903436894336785',
    ),
);

export const PAD_KEY_HASH = BigInt(
  '1309255631273308531193241901289907343161346846555918942743921933037802809814',
);
